import { Box, Divider, Stack, Typography } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import Button from "../Button";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import CountdownTimer from "../CountdownTimer";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import LoginIcon from "@mui/icons-material/Login";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export const PodCard = (props) => {
  const {
    pod,
    openDate,
    openTime,
    timezones,
    membersJoined,
    closeTime,
    isLive,
    onJoinSession,
    openDateString,
    onCancelPost,
  } = props;

  const navigate = useNavigate();
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000); // updates every second

    return () => clearInterval(timer); // clean up on unmount
  }, []);

  const renderContainerWidth = () => {
    if (pod.submissionOpen && pod.joined)
      return { xs: "100%", lg: "fit-content" };
    return { xs: "100%", md: "fit-content" };
  };

  const renderButton = () => {
    const isSubmissionOpen = pod.submissionOpen;
    const isEngagementOpen = pod.engagementOpen;
    const joined = pod.joined;
    const podcutoffTime = new Date(pod.cutoffTimeISO);
    const podOpenTime = new Date(pod.podOpenTimeISO);
    const engagementOpenTime = new Date(pod.engagementOpenTimeISO);
    const engagementDeadline = new Date(pod.engagementDeadlineISO);
    if (
      currentTime <= engagementDeadline &&
      currentTime >= engagementOpenTime &&
      joined
    ) {
      return (
        <Button
          variant="outlined"
          endIcon={<LoginIcon />}
          color="error"
          style={{
            color: "#D61F1F",
            border: "1px solid #D61F1F",
            fontWeight: 600,
          }}
          onClick={() => navigate(`/PodCommunity/Session/${pod.sessionId}`)}
        >
          Enter
        </Button>
      );
    }

    if (isSubmissionOpen && joined) {
      return (
        <Stack direction={"row"} gap={1}>
          <Button
            variant="outlined"
            startIcon={<CloseIcon />}
            color="error"
            style={{
              color: "#D61F1F",
              border: "1px solid #D61F1F",
              fontWeight: 600,
            }}
            onClick={onCancelPost}
            sx={{ width: { xs: "100%", lg: "fit-content" } }}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            startIcon={<ModeEditIcon />}
            onClick={() => onJoinSession(true)}
            style={{
              fontWeight: 600,
            }}
            sx={{ width: { xs: "100%", lg: "fit-content" } }}
          >
            Update post
          </Button>
        </Stack>
      );
    }

    if (!joined && currentTime >= podcutoffTime) {
      return (
        <Button disabled sx={{ width: "100%" }} style={{ fontWeight: 600 }}>
          Ongoing
        </Button>
      );
    }

    if (!joined && currentTime <= podcutoffTime && currentTime >= podOpenTime) {
      return (
        <Button
          startIcon={<AddCircleIcon />}
          style={{ fontWeight: 600 }}
          onClick={onJoinSession}
          sx={{ width: { xs: "100%", lg: "fit-content" } }}
        >
          Submit Link
        </Button>
      );
    }

    if (!isSubmissionOpen && !isEngagementOpen) {
      return (
        <Button
          disabled
          style={{ fontWeight: 600 }}
          sx={{ width: { xs: "100%", lg: "fit-content" } }}
        >
          Come Back Later
        </Button>
      );
    }
  };

  const renderTimeline = () => {
    return (
      <Typography
        color={isLive ? "#D61F1F" : "#415058"}
        fontWeight={600}
        fontSize={".875rem"}
        pt={"1px"}
      >
        <CountdownTimer
          targetTime={openDateString}
          render={(timeLeft) => {
            const parts = [];
            if (timeLeft.days) parts.push(`${timeLeft.days}d`);
            if (timeLeft.hours) parts.push(`${timeLeft.hours}h`);
            if (timeLeft.minutes || parts.length === 0)
              parts.push(`${timeLeft.minutes}m`);

            if (isLive && parts[0] === "0m") {
              return <>Session Live</>;
            }
            return <>Starts in {parts.join(" ")}</>;
          }}
        />
      </Typography>
    );
  };

  return (
    <Stack
      border="1px solid #E0E2E4"
      borderRadius={".875rem"}
      p={2.5}
      gap={1.5}
      backgroundColor="#FFF"
      style={{
        background: isLive
          ? "linear-gradient(90deg, rgba(214, 31, 31, 0.00) 0%, rgba(214, 31, 31, 0.03) 100%), #FFF"
          : "#FFF",
      }}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        flexWrap={"wrap"}
        gap={2}
      >
        <Stack gap={"4px"}>
          <Stack direction={"row"} alignItems={"center"} gap={1}>
            <Typography color="#1F292E" fontSize={"1rem"} fontWeight={600}>
              {openDate}
            </Typography>
            <CircleIcon sx={{ width: 6, height: 6 }} color="#415058" />
            <Typography fontSize={"1rem"} color="#415058" fontWeight={600}>
              {openTime} - {closeTime}
            </Typography>
          </Stack>
          <Typography color="#415058" fontWeight={600} fontSize={".95rem"}>
            Recommended for {timezones} time zones
          </Typography>
        </Stack>
        <Box pb={{ xs: 1, md: 0 }} width={renderContainerWidth()}>
          {renderButton()}
        </Box>
      </Stack>
      <Divider />
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Stack direction={"row"} alignItems={"center"} gap={0.5}>
          <TimerOutlinedIcon
            fontSize="small"
            sx={{
              color: isLive ? "#D61F1F" : "#415058",
            }}
          />
          {renderTimeline()}
        </Stack>
        {membersJoined > 30 && (
          <Stack>
            <Typography color="#415058" fontWeight={600} fontSize={".875rem"}>
              + {membersJoined} members joined
            </Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
